import { SubscriptionPageContainer } from '../Subscription/SubscriptionPageContainer';

export const BillingPage = () => {
  return <SubscriptionPageContainer />;
};
